import React, { useEffect } from 'react';

import MagicLogin from '@pray/shared/components/MagicLogin/MagicLogin';
import Spinner from '@pray/shared/components/v1/Spinner/Spinner';

import { useCreditPlans } from '@/hooks/credits';

import CheckoutOnboardingStep from './steps/CheckoutOnboardingStep';
import EmailOnboardingStep from './steps/EmailOnboardingStep';
import MinistryInfoOnboardingStep from './steps/MinistryInfo/MinistryInfoOnboardingStep';
import NameOnboardingStep from './steps/NameOnboardingStep';
import PricingPaywallOnboardingStep from './steps/PricingPaywallOnboardingStep';
import usePlgOnboardingFlow from './usePlgOnboardingFlow';
import { Steps } from './utils/constants';

function OnboardingStep({ component: Component, form, onContinue, onBack, props }) {
  return <Component form={form} onContinue={onContinue} onBack={onBack} {...props} />;
}

export default function PlgOnboardingFlow() {
  /** Pre-fetch the credit plans from the backend */
  useCreditPlans();

  useEffect(() => {
    document.body.classList.add('theme-dark');
    document.body.classList.remove('theme-light');
  }, []);

  const { form, currentStep, currentStepProps, isLoading, moveForward, moveBackward } = usePlgOnboardingFlow();

  const stepComponents = {
    [Steps.LOGIN]: EmailOnboardingStep,
    [Steps.NAME]: NameOnboardingStep,
    [Steps.MINISTRY_INFO]: MinistryInfoOnboardingStep,
    [Steps.PRICING_PAYWALL]: PricingPaywallOnboardingStep,
    [Steps.CHECKOUT]: CheckoutOnboardingStep,
  };

  if (isLoading) {
    return (
      <>
        <div className="flex h-screen w-full items-center justify-center">
          <Spinner color="white" size="medium" />
        </div>
        {/* Stays mounted across the loading gate. A magic-link arrival becomes registered mid-login,
            which is exactly what turns the gate on, so unmounting here would tear MagicLogin down
            while it is still finishing that login and reporting its outcome. */}
        <MagicLogin handleSuccessfulLogin={moveForward} />
      </>
    );
  }

  const StepComponent = stepComponents[currentStep];

  if (!StepComponent) return null;

  return (
    <>
      <OnboardingStep
        form={form}
        component={StepComponent}
        props={currentStepProps}
        onContinue={moveForward}
        onBack={moveBackward}
      />
      <MagicLogin handleSuccessfulLogin={moveForward} />
    </>
  );
}
